enum awards {
    HEAD_COACH = 'Head Coach',
    GENERAL_MANAGER = 'General Manager',
    OTHER = 'Other',
    PLAYER = 'Player',
    TEAM = 'Team',
}

enum awardStatuses {
    WINNER = 'WINNER',
    RUNNER_UP = 'RUNNER_UP',
    FINALIST = 'FINALIST',
}

export const NO_STANLEY_CUP_WINNER = 19181919;

export { awardStatuses };

export default awards;
